import React from 'react';
import CRMBoard from '../../components/admin-dashboard/crm/CRMBoard';

const PharmaCRM = () => {
  return <CRMBoard pipelineType="pharma" />;
};

export default PharmaCRM;

